var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIzicareLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 650 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff305e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M463.18,120.61s-.05,0-.08,0c-3.02,0-5.46-1.32-5.46-5.65v-58.79c0-3.33-2.7-6.02-6.02-6.02h-17.27c-.92,0-1.71.64-1.91,1.54h0c-.29,1.33-1.79,1.94-2.95,1.24-6.5-3.92-14.14-5.41-22.52-5.41-28.26,0-49.55,21.1-49.55,53.32s17.71,49.17,42.58,49.17c14.51,0,25.25-6.59,30.52-14.13,2.64,7.54,8.86,12.81,21.67,12.81,7.16,0,12.25-1.32,16.77-3.39v-19.12c0-3.15-2.61-5.58-5.76-5.56ZM426.92,110.15c0,1-.23,2-.73,2.87-3.25,5.71-10.2,9.09-16.99,9.09-11.68,0-19.97-7.72-19.97-23.17s9.23-25.25,21.48-25.25c5.11,0,9.38.84,13.28,3.09,1.83,1.05,2.92,3.05,2.92,5.17v28.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.4,50h-4.8c-7.21,0-13.05,5.84-13.05,13.05v84.31h30.9V63.05c0-7.21-5.84-13.05-13.05-13.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.45,50h-4.8c-7.21,0-13.05,5.84-13.05,13.05v84.31h30.9V63.05c0-7.21-5.84-13.05-13.05-13.05Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.33,23.61c-9.16-2.49-18.1-3.61-28.01-3.61-39.19,0-66.51,24.87-66.51,66.69s28.64,63.31,67.07,63.31c11.49,0,23.55-1.88,31.84-4.71v-19.91c0-4.07-3.95-6.94-7.84-5.74-6,1.85-11.95,2.67-19.48,2.67-25.81,0-39.94-13.56-39.94-37.12s13.94-37.49,39.19-37.49c7.08,0,13.74,1.03,20.2,3.22,3.87,1.31,7.87-1.65,7.87-5.73v-15.77c0-2.7-1.79-5.09-4.39-5.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M544.33,48.23c-1.72-.24-3.44-.34-5.36-.34-7.93,0-15.97,3.44-21.5,10.14-1.62,1.96-4.76,1.26-5.31-1.22l-.42-1.93c-.61-2.76-3.05-4.73-5.88-4.73h-14.19c-3.33,0-6.02,2.7-6.02,6.02v91.19h30.9v-47.1c.75-18.09,11.68-24.3,22.42-24.3,1.4,0,2.7.07,3.88.2,3.56.38,6.67-2.4,6.67-5.98v-15.97c0-3.01-2.22-5.55-5.19-5.97Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603.09,47.51c-29.01,0-50.12,20.16-50.12,51.25,0,37.87,28.07,51.25,53.88,51.25,12.06,0,25.25-1.51,36.74-7.35v-15.72c0-4.11-4.03-7.01-7.93-5.71-8.08,2.71-15.7,4.09-22.97,4.09-13.44,0-22.64-4.68-26.58-14.28-.82-1.99.63-4.18,2.78-4.18h54.94c3.24,0,5.91-2.57,6.02-5.81.08-2.25.13-4.56.13-7.19-.56-29.96-18.65-46.35-46.91-46.35ZM616.76,89.52h-28.26c-2.02,0-3.5-1.97-2.88-3.89,2.91-9.05,9.17-13.44,17.47-13.44,8.94,0,14.71,4.23,16.63,13.77.37,1.84-1.08,3.56-2.96,3.56Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20,
    cy: 20,
    r: 20
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 172.05,
    cy: 20,
    r: 20
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.06,50.12H59.2c-3.33,0-6.02,2.7-6.02,6.02v13.01c0,3.33,2.7,6.02,6.02,6.02h53.99c2.55,0,3.95,2.97,2.32,4.94l-16.96,20.42c-2.17,2.62-.31,6.58,3.09,6.58h9.04c1.2,0,2.33-.53,3.09-1.46l23.94-28.95c.89-1.08,1.38-2.44,1.38-3.84v-16.74c0-3.33-2.7-6.02-6.02-6.02Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.06,122.3h-53.99c-2.55,0-3.95-2.97-2.32-4.94l16.96-20.42c2.17-2.62.31-6.58-3.09-6.58h-9.04c-1.2,0-2.33.53-3.09,1.46l-23.94,28.95c-.89,1.08-1.38,2.44-1.38,3.84v22.76h85.91v-19.04c0-3.33-2.7-6.02-6.02-6.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIzicareLogo);
export default __webpack_public_path__ + "static/media/izicare_logo.e3ea31c66ddfd2cee94799165b44e57e.svg";
export { ForwardRef as ReactComponent };